export const navBar = {
    position: "absolute",
    zIndex: "1",
    right: "0"
};

export const bodies = {
    position: "absolute",
    transition: "all 1.5s ease-out"
};
